/*
  <lazy-video> defers downloading a wrapped <video> until it is within 300px of the viewport.
  Expects the <video> to be rendered with preload="none" and no autoplay attribute.
  data-autoplay="true" plays on entry and pauses on exit; otherwise playback stays click-driven.
*/
(function () {
  if (customElements.get('lazy-video')) return;

  const ROOT_MARGIN = '300px';

  class LazyVideo extends HTMLElement {
    constructor() {
      super();
      this.video = null;
      this.observer = null;
      this.autoplay = false;
      this.onIntersect = this.onIntersect.bind(this);
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.autoplay = this.dataset.autoplay === 'true';
      // iOS refuses inline programmatic playback without this attribute
      this.video.setAttribute('playsinline', '');

      if (!('IntersectionObserver' in window)) {
        this.activate();
        return;
      }

      this.observer = new IntersectionObserver(this.onIntersect, { rootMargin: ROOT_MARGIN });
      this.observer.observe(this.video);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activate();
        } else if (this.autoplay && !this.video.paused) {
          this.video.pause();
        }
      });
    }

    activate() {
      this.video.setAttribute('preload', this.autoplay ? 'auto' : 'metadata');
      if (!this.autoplay) return;

      const playing = this.video.play();
      if (playing && typeof playing.catch === 'function') {
        playing.catch((error) => {
          console.debug('lazy-video: autoplay was blocked by the browser', error);
        });
      }
    }
  }

  customElements.define('lazy-video', LazyVideo);
})();
